import { defineAsyncComponent } from 'vue';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const CryptoBookNavigation = defineAsyncComponent(() => import('@/js/pages/crypto-book/CryptoBookNavigation.vue'));
const UserReviewModal = defineAsyncComponent(() => import('@/js/pages/crypto-book/UserReviewModal.vue'));

app.component('CryptoBookNavigation', CryptoBookNavigation);
app.component('UserReviewModal', UserReviewModal);

mountApp();
